import React from 'react';
import { motion } from 'framer-motion';
import { EyeOff, CalendarX, Compass, Users } from 'lucide-react';
const problems = [{
  icon: EyeOff,
  title: 'Light Pollution Blindness',
  description: "Urban skyglow drowns out 80% of visible stars. Starkeep's pollution-aware maps reveal the clearest observation windows from your exact location."
}, {
  icon: CalendarX,
  title: 'Missed Celestial Events',
  description: "Meteor showers, eclipses, and planetary conjunctions happen on nature's schedule. Our Nova Beacon alert system ensures you never miss a cosmic moment again."
}, {
  icon: Compass,
  title: 'Equipment Overwhelm',
  description: "Choosing between telescopes, mounts, and eyepieces paralyzes newcomers. Starkeep's guided equipment matcher pairs your budget and goals with the perfect setup."
}, {
  icon: Users,
  title: 'Isolated Stargazing',
  description: 'Astronomy thrives in community, yet most enthusiasts observe alone. Connect with local stargazing circles and share discoveries through our Orbit Pulse network.'
}];
export function ProblemsSection() {
  return <section id="problems" className="py-24 relative z-10" data-id="element-136">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
        <div className="text-center mb-16" data-id="element-138">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 drop-shadow-[0_0_10px_rgba(255,255,255,0.2)]" data-id="element-139">
            The Night Sky Shouldn't Be This Hard
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-140">
            We've solved the biggest hurdles standing between you and the stars.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-141">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="group relative p-8 rounded-2xl bg-slate-900/40 backdrop-blur-md border border-slate-800 hover:border-cyan-500/30 transition-all duration-300 hover:bg-slate-800/40" data-id="element-142">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl" data-id="element-143" />

              <div className="relative z-10 flex flex-col sm:flex-row gap-6 items-start" data-id="element-144">
                <div className="p-3 rounded-xl bg-slate-800/50 border border-slate-700 group-hover:border-cyan-500/50 group-hover:shadow-[0_0_15px_rgba(6,182,212,0.2)] transition-all" data-id="element-145">
                  <problem.icon className="w-8 h-8 text-cyan-400" data-id="element-146" />
                </div>
                <div data-id="element-147">
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-cyan-200 transition-colors" data-id="element-148">
                    {problem.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-149">
                    {problem.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}